/* AIMAR EVENTOS — Theme JavaScript */

document.addEventListener('DOMContentLoaded', function () {

    /* ── Mobile menu ── */
    const toggle = document.querySelector('.menu-toggle');
    const nav = document.querySelector('nav');
    if (toggle && nav) {
        toggle.addEventListener('click', () => nav.classList.toggle('open'));
    }

    /* ── Favorites button — prevent propagating click to parent <a> ── */
    document.querySelectorAll('.prod-fav').forEach(btn => {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            this.textContent = this.textContent === '🤍' ? '❤️' : '🤍';
        });
    });

    /* ── Product image thumbnails ── */
    document.querySelectorAll('.thumb').forEach(thumb => {
        thumb.addEventListener('click', function () {
            const main = document.querySelector('.main-img');
            if (main) main.src = this.src;
            document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
            this.classList.add('active');
        });
    });

    /* ── Announcement bar dismiss ── */
    const ann = document.querySelector('.ann-bar');
    if (ann) ann.addEventListener('click', () => ann.style.display = 'none');

    /* ── Cart count update from Shopify cart ── */
    fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
            const el = document.querySelector('.cart-badge');
            if (el && cart.item_count > 0) {
                el.textContent = cart.item_count;
                el.style.display = 'inline-flex';
            }
        })
        .catch(() => {});

    /* ── Add to cart AJAX ── */
    document.querySelectorAll('.btn-add').forEach(btn => {
        btn.addEventListener('click', function (e) {
            const variantId = this.dataset.variantId;
            if (!variantId) return;
            e.preventDefault();
            const orig = this.textContent;
            this.textContent = '⏳ Agregando...';
            this.disabled = true;
            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: 1 })
            })
            .then(r => r.json())
            .then(() => {
                this.textContent = '✓ Agregado';
                this.style.background = '#25D366';
                setTimeout(() => {
                    this.textContent = orig;
                    this.style.background = '';
                    this.disabled = false;
                }, 2000);
                return fetch('/cart.js');
            })
            .then(r => r.json())
            .then(cart => {
                const el = document.querySelector('.cart-badge');
                if (el) {
                    el.textContent = cart.item_count;
                    el.style.display = 'inline-flex';
                }
            })
            .catch(() => {
                this.textContent = orig;
                this.disabled = false;
            });
        });
    });

    /* ── Cart quantity update ── */
    document.querySelectorAll('.cart-qty input').forEach(input => {
        input.addEventListener('change', function () {
            const key = this.dataset.key;
            const qty = parseInt(this.value) || 0;
            if (!key) return;
            fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: key, quantity: qty })
            }).then(() => location.reload());
        });
    });

});
